const { getElement, getElements } = window.BAO.Utils

class GiftBar extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: flex;
      }
    `
  }

  static get requiredElements () {
    return ['added', 'input']
  }

  checkValidity () {
    super.checkValidity()

    if (!this.dataset.productId) {
      this.throwError(
        `Missing "data-product-id" on "gift-bar.${this.className}`,
      )
    }

    if (!this.dataset.variantId) {
      this.throwError(
        `Missing "data-variant-id" on "gift-bar.${this.className}`,
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onSelfClick = this.onSelfClick.bind(this)

    this.listeners.add(this, 'click', this.onSelfClick)
  }

  onSelfClick (event) {
    event.preventDefault()

    this.giftDrawer.activator = this
    this.giftDrawer.productId = this.dataset.productId
    this.giftDrawer.variantId = this.dataset.variantId

    if (this.giftMessage) {
      this.giftDrawer.giftMessage = this.giftMessage
    }

    if (this.currentPackagingChoice) {
      this.giftDrawer.currentPackagingChoice = this.currentPackagingChoice
    }

    if (this.extrasIds.length > 0) {
      this.giftDrawer.extras.forEach(el => {
        el.setAttribute(
          'aria-selected',
          this.extrasIds.includes(Number(el.dataset.variantId)).toString(),
        )
      })
    }

    this.giftDrawerController.open(this.productType)
  }

  get giftDrawerController () {
    return getElement('gift-drawer-controller')
  }

  get giftDrawer () {
    return getElements('gift-drawer').find(
      drawer => drawer.productType === this.productType,
    )
  }

  get cartItem () {
    return this.closest('cart-item')
  }

  get applyAsAdd () {
    return this.dataset.applyAsAdd === 'true'
  }

  get applyAsUpdate () {
    return this.dataset.applyAsUpdate === 'true'
  }

  get updateKey () {
    return this.dataset.updateKey
  }

  get currentPackagingChoice () {
    return this.giftDrawer.packaging.find(
      el => el.dataset.variantId === this.packagingId.toString(),
    )
  }

  get giftingMessage () {
    if (!this?.els?.added) return ''

    return this.els.added.element.value
  }

  /**
   * @returns {boolean}
   * @public
   */
  get hasGifting () {
    return this.dataset.active === 'true'
  }

  /**
   * @param {boolean} val
   */
  set hasGifting (val) {
    this.dataset.active = val.toString()

    this.els.input.element.checked = val
  }

  /**
   * @returns {string}
   * @public
   */
  get giftMessage () {
    return this.dataset.giftMessage
  }

  /**
   * @param {string} val
   */
  set giftMessage (val) {
    this.dataset.giftMessage = val
  }

  /**
   * @type {number[]}
   * @public
   */
  get extrasIds () {
    const ids = this.dataset.extrasIds.split(',').filter(Boolean)
    if (ids.length === 0) return []

    return ids.map(id => Number(id))
  }

  /**
   * @param {number[]} val
   */
  set extrasIds (val) {
    this.dataset.extrasIds = val.join(',')
  }

  /**
   * @type {number[]}
   * @public
   */
  get extrasIdsFree () {
    const ids = this.dataset.extrasIdsFree.split(',').filter(Boolean)
    if (ids.length === 0) return []

    return ids.map(id => id)
  }

  /**
   * @param {number[]} val
   */
  set extrasIdsFree (val) {
    this.dataset.extrasIdsFree = val.join(',')
  }

  /**
   * @type {number}
   * @public
   */
  get packagingId () {
    return Number(this.dataset.packagingId || undefined)
  }

  /**
   * @param {number} val
   */
  set packagingId (val) {
    this.dataset.packagingId = val?.toString()
  }

  /** @returns {string} */
  get productType () {
    return this.dataset.productType ?? 'default'
  }
}

if (!customElements.get('gift-bar')) {
  customElements.define('gift-bar', GiftBar)
}
